module.exports = __webpack_public_path__ + "static/media/btn_parents_04_blog_video-POPA.25df5e33.png";